import { CommonModule, NgClass } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';

import * as AuthActions from '@core/redux/auth/auth.actions';
import * as fromRoot from '@core/redux/index';
import { select, Store } from '@ngrx/store';

declare let gapi: any;

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.less'],
  standalone: true,
  imports: [ReactiveFormsModule, NgClass, CommonModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignUpComponent implements OnInit, OnDestroy, AfterViewInit {
  private store = inject<Store<fromRoot.State>>(Store);
  private formBuilder = inject(FormBuilder);
  private zone = inject(NgZone);

  private destroyRef = inject(DestroyRef);
  form: FormGroup;
  validateErrors: any = {};
  isSending = false;
  googleAuth: any;

  constructor() {
    this.store.pipe(select(fromRoot.getAuthErrors), takeUntilDestroyed(this.destroyRef)).subscribe(errors => {
      this.validateErrors = errors;
    });

    this.store.pipe(select(fromRoot.getLoading), takeUntilDestroyed(this.destroyRef)).subscribe(isSending => {
      this.isSending = isSending;
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: [null, Validators.compose([Validators.required, Validators.email])],
    });
  }

  ngAfterViewInit() {
    this.zone.run(() => {
      gapi.load('auth2', () => {
        this.googleAuth = gapi.auth2.init({
          clientId: '1049746922847-fk4hg4fb1787947gjnkcaadd7nn4p4gd.apps.googleusercontent.com',
          scope: 'email profile',
        });
      });
    });
  }

  ngOnDestroy() {}

  onGoogleAuth() {
    this.googleAuth.grantOfflineAccess().then(result => this._signInSuccessHandler(result));
  }

  onSubmit() {
    this.store.dispatch(new AuthActions.SignUpAction(this.form.getRawValue()));
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'input_theme-1_error': this.isFieldValid(field),
    };
  }

  private _signInSuccessHandler(result: { code }) {
    this.zone.run(() => {
      this.store.dispatch(new AuthActions.SignUpGoogleAction(result));
    });
  }
}
